import { render, staticRenderFns } from "./TMEC.vue?vue&type=template&id=13af3985&scoped=true&"
import script from "./TMEC.vue?vue&type=script&lang=js&"
export * from "./TMEC.vue?vue&type=script&lang=js&"
import style0 from "./TMEC.vue?vue&type=style&index=0&id=13af3985&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af3985",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
